/** venue 管理画面用フック（CRUD + promote） */

import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { venuesApi } from "../lib/api";

const VENUE_MGMT_KEY = ["venue-management"] as const;

export const useVenueList = () => {
  return useQuery({
    queryKey: VENUE_MGMT_KEY,
    queryFn: async () => {
      const res = await venuesApi.$get();
      if (!res.ok) throw new Error("Failed to fetch venues");
      const json = await res.json();
      return json.data;
    },
  });
};

export const useCreateVenue = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (input: { name: string; strategy?: string }) => {
      const res = await venuesApi.$post({ json: input });
      if (!res.ok) {
        const json = await res.json();
        throw new Error(
          "error" in json ? json.error : "Failed to create venue",
        );
      }
      return res.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: VENUE_MGMT_KEY });
    },
  });
};

export const useUpdateVenue = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({
      id,
      data,
    }: {
      id: string;
      data: { name?: string; strategy?: string | null; disabled?: 0 | 1 };
    }) => {
      const res = await venuesApi[":id"].$patch({
        param: { id },
        json: data,
      });
      if (!res.ok) {
        const json = await res.json();
        throw new Error(
          "error" in json ? json.error : "Failed to update venue",
        );
      }
      return res.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: VENUE_MGMT_KEY });
    },
  });
};

export const useDeleteVenue = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (id: string) => {
      const res = await venuesApi[":id"].$delete({ param: { id } });
      if (!res.ok) throw new Error("Failed to delete venue");
      return res.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: VENUE_MGMT_KEY });
    },
  });
};

export const usePromoteVenue = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (input: { name: string; strategy?: string }) => {
      const res = await venuesApi.promote.$post({ json: input });
      if (!res.ok) {
        const json = await res.json();
        throw new Error(
          "error" in json ? json.error : "Failed to promote venue",
        );
      }
      return res.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: VENUE_MGMT_KEY });
    },
  });
};
